import {Directive, ElementRef} from '@angular/core';

declare var jquery: any;
declare var $: any;

@Directive({
    selector: '[appMenu]'
})
export class MenuDirective {
    currentElement: any;

    constructor(private el: ElementRef) {
        this.currentElement = el;
        $(document).ready(function () {
            $('a.burger-btn').on('click', function () {
                $('ul.toggle-content').slideToggle(400, function () {
                    if ($(this).is(':visible')) {
                        $(this).css('display','flex');
                    }
                });

            });
            $(window).on("load, resize", function() {
                var viewportWidth = $(window).width();
                if (viewportWidth > 991) {
                    $(".toggle-content").css('display','flex');
                    $(".top-bar-list").css('display','block');
                } else {
                    $(".toggle-content").css('display','none');
                    $(".top-bar-list").css('display','none');
                }

            });
            $('.top-bar-burger').on('click', function (e) {
                $('.top-bar-list').fadeIn();
                e.stopPropagation();
            });

            $('.mega-menu').mouseover(function (e) {
                if ($(this).children('div.mega-menu-content').length) {
                    $(this).addClass('sfHover');
                    $(this).children('div.mega-menu-content').show();
                }
            });

            $('.mega-menu').mouseout(function (e) {
                $(this).removeClass('sfHover');
                $(this).children('div.mega-menu-content').hide();
            });
            if ($(window).width() < 991) {
                $('body').on('click', function (e) {
                    $('.top-bar-list').fadeOut();

                });
            } else {
                $('body').off('click');

            }
            $(window).resize(function () {
                if ($(window).width() <= 991) {
                    $('#header').removeClass('fixed-header');
                        $('body').on('click', function (e) {
                            $('.top-bar-list').fadeOut();
                        });
                } else {
                    $('body').off('click');
                }
            });
            $(window).scroll(function () {
                const fixedNav = $('.fixed-nav');
                var header = $('#header'),
                    section = header.parent().next().next().children().first(),
                    topBar = $('#top-bar').height(),
                    headerH = header.height();

                if ($(window).width() > 991) {
                    if ($(window).scrollTop() >= topBar) {
                        header.addClass('fixed-header');
                        section.css('margin-top', headerH);
                    } else {
                        header.removeClass('fixed-header');
                        section.css('margin-top', 'inherit');
                    }
                }

                if (fixedNav.length) {
                    if ($(window).width() > 991) {
                        const window_top_position = $(window).scrollTop() + headerH,
                            element_top_position = fixedNav.offset().top;
                        $('.fixed').css('top', headerH);
                        if (window_top_position >= element_top_position) {
                            $('.fixed-nav .nav-parent').addClass('fixed container');
                        } else {
                            $('.fixed-nav .nav-parent').removeClass('fixed container');
                        }

                    } else {
                        const window_top_position = $(window).scrollTop(),
                            element_top_position = fixedNav.offset().top;
                        $('.fixed').css('top', 0);
                        if (window_top_position >= element_top_position) {

                            $('.fixed-nav .nav-parent').addClass('fixed container');
                        } else {
                            $('.fixed-nav .nav-parent').removeClass('fixed container');
                        }
                    }
                }
            });
        });
    }

}


// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/directives/menu.directive.ts